module.exports = "/app/user/img/SELECT.e10fddbb.png";